import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class IchimokuTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, displayFormat, yAccessor, options, textFill, labelFill } =
      this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let conversionLine, baseLine, spanA, spanB, laggingSpan;
    conversionLine = baseLine = spanA = spanB = laggingSpan = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      conversionLine = isDefined(item.conversionLine)
        ? displayFormat(item.conversionLine)
        : "n/a";
      baseLine = isDefined(item.baseLine)
        ? displayFormat(item.baseLine)
        : "n/a";
      spanA = isDefined(item.spanA) ? displayFormat(item.spanA) : "n/a";
      spanB = isDefined(item.spanB) ? displayFormat(item.spanB) : "n/a";
      laggingSpan = isDefined(item.laggingSpan)
        ? displayFormat(item.laggingSpan)
        : "n/a";
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const { conversionPeriod, basePeriod, spanBPeriod, displacement } = options;
    const tooltipLabel = `Ichimoku(${conversionPeriod}, ${basePeriod}, ${spanBPeriod}, ${displacement}): `;
    const tooltipValue = `Conv: ${conversionLine}, Base: ${baseLine}, SpanA: ${spanA}, SpanB: ${spanB}, Lagging: ${laggingSpan}`;
    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={this.props.className}
        onClick={onClick}
        data-evo-id="tooltip-ichimoku"
      >
        <ToolTipText
          x={0}
          y={0}
          fontFamily={this.props.fontFamily}
          fontSize={this.props.fontSize}
        >
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{tooltipValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

IchimokuTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  options: PropTypes.shape({
    conversionPeriod: PropTypes.number.isRequired,
    basePeriod: PropTypes.number.isRequired,
    spanBPeriod: PropTypes.number.isRequired,
    displacement: PropTypes.number.isRequired,
  }).isRequired,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
};

IchimokuTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-ichimoku-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
};

export default IchimokuTooltip;
